/* global wpbp_app */
// only load our form helpers if we have a form on the current page
jQuery($ => {
    if ($('form').length || window.patternlab) {
        require.ensure([], require => {
            let selectAll,
                fileInput,
                floatingLabel,
                $viewportMeta = $('meta[name="viewport"]'),
                viewportMetaContent = $viewportMeta.attr('content'),
                zoomEnableTimeout = function () {},
                $showSummary, $copyData,
                scrollTo = require('@spinnwerk/scroll-helper/lib/scroll-to').default;

            // prevent mobile zoom in
            $('input, select, textarea').bind('touchstart focus blur', function (event) {
                if (event.type === 'blur') {
                    zoomEnableTimeout = setTimeout(function () {
                        $viewportMeta.attr('content', viewportMetaContent);
                    }, 100);
                } else {
                    clearTimeout(zoomEnableTimeout);
                    $viewportMeta.attr('content', viewportMetaContent + ',maximum-scale=1');
                }
            });

            // include form validation via parsley (with German language)
            require('./validation');

            // enable an (de)select all radiobutton and checkboxes possibility
            selectAll = require('@spinnwerk/form-helper/select-all').default;
            selectAll();

            // style advanced file inputs
            fileInput = require('@spinnwerk/form-helper/file-input').default;
            fileInput({
                multibleFilesLabel: ':anz Dateien ausgewählt'
            });

            // automatically attach an loading indicator to submit buttons on form submit
            floatingLabel = require('@spinnwerk/form-helper/label-floating').default;
            floatingLabel();


            $showSummary = $('.js--show-summary');

            if ($showSummary.length) {
                $showSummary.each((i, el) => {
                    let $summaryButton = $(el),
                        onFormSubmit = event => event.preventDefault(),
                        $form = $summaryButton.closest('form').on('submit.js-show-summary', onFormSubmit);

                    $summaryButton.on('click', () => {
                        $form.parsley().whenValidate().then(() => {
                            $form.find('label').each((i, label) => {
                                let $label = $(label),
                                    $input = $label.find('input, select, textarea'),
                                    val, $detail;

                                if (!$input.length) {
                                    return;
                                }

                                if ($input.is('select')) {
                                    val = $input.find(`option[value='${$input.val()}']`).text();
                                } else if ($input.is('[type="checkbox"]')) {
                                    if ($input.prop('checked')) {
                                        $input.clone().attr('type', 'hidden').insertAfter($input);
                                    }

                                    $input.prop('disabled', true);
                                    return;
                                } else {
                                    val = $input.val();
                                }

                                $detail = $label.siblings('.js--summary__detail');

                                if ($detail.length) {
                                    $detail.find('span').text(val);
                                    $detail.show();
                                } else {
                                    $(`<div class="js--summary__detail">
                                        <strong>${$label.find('.label-floating__label').text()}</strong>: <span>${val}</span>
                                    </div>`).insertAfter($label);
                                }

                                $label.hide();
                            });

                            $summaryButton.hide();
                            $copyData.hide();
                            $form.closest('.wpcf7').siblings('p').hide();
                            $('.js--initial-text').hide();
                            $('.js--review-text').show();
                            $form.off('submit.js-show-summary').find('.js--summary-controls').show();

                            scrollTo({ duration: 500 });
                        });
                    });

                    $('.js--summary-back').on('click', event => {
                        let $button = $(event.target),
                            $form = $button.closest('form');

                        $form.on('submit.js-show-summary', onFormSubmit)
                            .find('.js--summary__detail').hide()
                            .end()
                            .find('label').show()
                            .end()
                            .find('input[disabled] + input[type="hidden"]').remove()
                            .end()
                            .find('input[disabled]').prop('disabled', false);

                        $form.closest('.wpcf7').siblings('p').show();
                        $('.js--initial-text').show();
                        $('.js--review-text').hide();
                        $copyData.show();
                        $button.closest('.js--summary-controls').hide();
                        $summaryButton.show();
                    });

                    $form.closest('.wpcf7').on('wpcf7mailsent', () => {
                        /* eslint-disable camelcase */
                        if (wpbp_app && wpbp_app.redirect) {
                            location.href = wpbp_app.redirect;
                        }
                        /* eslint-enable */
                    });
                });
            }

            $copyData = $('.js--copy-data').on('click', event => {
                let $button = $(event.target),
                    $form = $button.closest('form');

                $form.find('input[name="firma_abweichend"]').val($form.find('input[name="firma"]').val()).trigger('focusout');
                $form.find('input[name="vorname_abweichend"]').val($form.find('input[name="vorname"]').val()).trigger('focusout');
                $form.find('input[name="nachname_abweichend"]').val($form.find('input[name="nachname"]').val()).trigger('focusout');
                $form.find('input[name="adresse_abweichend"]').val($form.find('input[name="adresse"]').val()).trigger('focusout');
                $form.find('input[name="zip_abweichend"]').val($form.find('input[name="zip"]').val()).trigger('focusout');
                $form.find('input[name="ort_abweichend"]').val($form.find('input[name="ort"]').val()).trigger('focusout');
                $form.find('input[name="land_abweichend"]').val($form.find('input[name="land"]').val()).trigger('focusout');
                $form.find('input[name="position_abweichend"]').val($form.find('input[name="position"]').val()).trigger('focusout');
                $form.find('input[name="email_abweichend"]').val($form.find('input[name="email"]').val()).trigger('focusout');
            });

        }, 'form-helpers');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/form/form.js